import { createApp } from 'vue';
import App from './App.vue';
import '../../common-style/util.css';
import '../../app.css';
import './album.css';
import hevueImgPreview from 'hevue-img-preview';
createApp(App)
  .use(hevueImgPreview)
  .mount('#app');

